const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconZoomIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.746,
    height: 12.746,
    fill: "none",
    viewBox: "0 0 12.746 12.746",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.7795 0 0 3.7795 -2966.2 104.38)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 784.81,
    y: -26.28,
    width: 3.3723,
    height: 0.69771,
    rx: 0.34885,
    ry: 0.34885,
    style: {
      fillRule: "evenodd",
      fill: "#000",
      paintOrder: "stroke markers fill",
      stopColor: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 100,
      strokeWidth: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90)",
    x: -27.618,
    y: -786.84,
    width: 3.3723,
    height: 0.69771,
    rx: 0.34885,
    ry: 0.34885,
    style: {
      fillRule: "evenodd",
      fill: "#000",
      paintOrder: "stroke markers fill",
      stopColor: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 100,
      strokeWidth: 10
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZoomIn);
export default __webpack_public_path__ + "static/media/icon_zoom_in.7ca9f77d41df82ebbda8dff3e29dc2b7.svg";
export { ForwardRef as ReactComponent };